export const CLOSE_STORE_DETAILS = 'CLOSE_STORE_DETAILS'
export const OPEN_STORE_DETAILS = 'OPEN_STORE_DETAILS'
